import { ProductSearchResultItem } from '../globalSearch.types';
import { GlobalSearchListItem } from '../staticCommands/staticCommands.types';

interface UseGlobalSearchItemActivationParams {
  onAddProductToOrder: (item: ProductSearchResultItem) => void;
}

const useGlobalSearchItemActivation = ({
  onAddProductToOrder,
}: UseGlobalSearchItemActivationParams) => {
  const handleActivateItemAction = (listItem: GlobalSearchListItem) => {
    if (listItem.kind === 'command') {
      return;
    }
    const { item } = listItem;
    if (item.entityType === 'product') {
      onAddProductToOrder(item);
    }
  };

  return { handleActivateItemAction };
};

export default useGlobalSearchItemActivation;
